import { Field, Model, Name, PrimitiveSerializer, Type } from 'serialize-ts';
import { AttributeValueType } from './attribute-value-type.model';
import { FileExtensionTypes } from './file-extension-types.enum';
import { SubstituteType } from './substitute-type.interface';

@Model()
export class ProductAttribute {

  @Field()
  aggregated: boolean;

  @Field()
  id: string;

  @Field()
  @Name('frontend')
  type: string;

  @Field()
  @Name('type')
  valueType: AttributeValueType;

  @Field()
  label: string;

  @Field()
  value: string;

  @Field()
  code: string;

  @Field()
  displayUnit: string;

  @Field()
  translatable: boolean;

  @Field()
  @Type(new PrimitiveSerializer())
  substitutes: SubstituteType;

  fileExtension?: FileExtensionTypes;
}

@Model()
export class ProductAttributeSPD {

  @Field()
  aggregated: boolean;

  @Field()
  id: string;

  @Field()
  @Name('frontend')
  type: string;

  @Field()
  @Name('type')
  valueType: number;

  @Field()
  label: string;

  @Field()
  value: string;

  @Field()
  code: string;

  @Field()
  displayUnit: string;

  @Field()
  translatable: boolean;

  @Field()
  @Type(new PrimitiveSerializer())
  substitutes: SubstituteType;

  fileExtension?: FileExtensionTypes;
}
